import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FormFieldSelect } from '../../components/Form/FormField';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { PageBody } from '../../components/SiteWrapper';
import AadharCandidates from '../Dashboard/SuperAdmin/AadharCandidates';
import * as NodalApi from '../../api/NodalApi';

const NodalShiftWiseAttendance = () => {
  const [exams, setExams] = useState([]);
  const [examDays, setExamDays] = useState([]);
  const [rrbs, setRrbs] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  const defaultFilterValue = {
    exam: '',
  };
  const {
    control,
    formState: { errors: dashboardFilterError },
    watch,
    setValue,
    getValues,
  } = useForm({
    mode: 'onChange',
    defaultValues: defaultFilterValue,
  });
  const [filter, setFilter] = useState({
    _page: 1,
    _limit: 1000,
    q: '',
    _sort: '',
    _order: 'desc',
    ministry_exam_id: null,
    rrb: null,
  });

  const selectedExam = watch('exam');
  const selectedExamDay = watch('examDay');
  const selectedRrb = watch('rrb');

  const fetchNodalExams = useMemo(() => {
    return async () => {
      setIsLoading(true);
      try {
        const res = await NodalApi.getAll(filter);
        setExams(res?.data?.nodal_exams);
        const examDaysOptions = res?.data?.exam_days
          ? [...new Set(res.data.exam_days)]
              .sort((a, b) => new Date(a) - new Date(b)) // Sort before mapping
              .map((date) => {
                return date;
              })
          : [];

        setExamDays(examDaysOptions);
        const rrbs = res?.data?.rrb_list
          ? res.data.rrb_list.map((rrb) => {
              return {
                label: rrb.name,
                value: rrb.id,
              };
            })
          : [];
        setRrbs(rrbs);

        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    };
  });

  useEffect(() => {
    fetchNodalExams();
  }, [filter]);

  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      ministry_exam_id: selectedExam?.value || null,
    }));
  }, [selectedExam]);

  useEffect(() => {
    setFilter((prev) => ({ ...prev, rrb: selectedRrb?.value || null }));
  }, [selectedRrb]);

  useEffect(() => {
    // Check if all values were previously selected
    const allValuesSelected = selectedExam && selectedExamDay && selectedRrb;

    if (allValuesSelected) {
      // Reset exam day to default (current date or first available date)
      const defaultExamDay = examDays.includes(moment().format('DD/MM/YYYY'))
        ? moment().format('DD/MM/YYYY')
        : examDays[0] || '';

      setValue('examDay', defaultExamDay);

      // Reset RRB to 'All Rrbs'
      setValue('rrb', { label: 'All Rrbs', value: null });

      // Update the filter accordingly
      setFilter((prev) => ({
        ...prev,
        rrb: null,
        selectedExamDay: defaultExamDay,
      }));
    }
  }, [selectedExam]);

  return (
    <div className='bg-white m-0 my-3 p-0 mx-3 rounded shadow-rrb'>
      <PageBody
        className='p-0 m-0'
        containerStyles={{ margin: 0, padding: 0 }}
        isNodalReport
      >
        <div className='px-3 py-0'>
          <Col md='12'>
            <Row className='d-flex align-items-center mb-2'>
              <Col md='6'>
                <h2 className='page-title'>Shift Wise Attendance</h2>
              </Col>
              <Col md='2'>
                <FormFieldSelect
                  name='exam'
                  control={control}
                  options={exams.map((exam) => ({
                    label: exam.exam_name,
                    value: exam.id,
                  }))}
                  error={dashboardFilterError?.exam}
                  size='12'
                  placeholder='Select Exam'
                  className='shadow-none'
                />
              </Col>
              <Col md='2'>
                <FormFieldSelect
                  name='examDay'
                  control={control}
                  options={[
                    ...(examDays || [])
                      .filter((date) => date !== moment().format('DD/MM/YYYY')) // Exclude current date if already in list
                      .map((date) => ({
                        label: moment(date).format('DD/MM/YYYY'),
                        value: date,
                      })),
                  ]}
                  error={dashboardFilterError?.examDay}
                  size='12'
                  placeholder={moment().format('DD/MM/YYYY')} // Show current date as placeholder
                  defaultValue={{
                    label: moment().format('DD/MM/YYYY'),
                    value: moment(),
                  }} // Pre-select current date
                  disabled={!selectedExam}
                  className='shadow-none'
                />
              </Col>
              <Col md='2'>
                <FormFieldSelect
                  name='rrb'
                  control={control}
                  options={[
                    { label: 'All Rrbs', value: null },
                    ...(rrbs || []), // Ensures rrbs is always an array to avoid errors
                  ]}
                  error={dashboardFilterError?.rrb}
                  size='12'
                  placeholder='Select Rrb'
                  className='shadow-none'
                />
              </Col>
            </Row>
          </Col>
        </div>
        <Row>
          <AadharCandidates
            className='shadow-none'
            isNodal={true}
            noddle_selected_rrb_id={selectedRrb}
            selectedDate={selectedExamDay}
            selectedExam={selectedExam}
            dataTableCardClass='shadow-none border-0 border-top bor rounded-0'
          />
        </Row>
      </PageBody>
    </div>
  );
};

export default NodalShiftWiseAttendance;
